import { useIntl } from 'react-intl';

import {
  dangerouslyConvertPrivacyString,
  type PIIString,
} from '@trello/privacy';

export type PageTitle = 'Activity' | 'Cards' | 'Profile' | 'Settings';

const getMemberViewTitle = (username?: PIIString, name?: PIIString) => {
  return `${dangerouslyConvertPrivacyString(name)} (${dangerouslyConvertPrivacyString(username)})`;
};

export const usePageTitle = ({
  title,
  username,
  name,
  isMemberMe,
}: {
  title: PageTitle;
  username?: PIIString;
  name?: PIIString;
  isMemberMe: boolean;
}): string => {
  const intl = useIntl();

  if (!isMemberMe) {
    return getMemberViewTitle(username, name);
  }

  switch (title) {
    case 'Profile':
      return intl.formatMessage({
        id: 'page title.profile',
        defaultMessage: 'Profile',
        description: 'Profile',
      });
    case 'Activity':
      return intl.formatMessage({
        id: 'page title.activity',
        defaultMessage: 'Activity',
        description: 'Activity',
      });
    case 'Cards':
      return intl.formatMessage({
        id: 'page title.cards',
        defaultMessage: 'Cards',
        description: 'Cards',
      });
    case 'Settings':
      return intl.formatMessage({
        id: 'page title.settings',
        defaultMessage: 'Settings',
        description: 'Settings',
      });
    default:
      return '';
  }
};
